import _slicedToArray from "E:\\Agents\\Agent-02\\_work\\45\\s\\src\\apps\\vdsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import './FileUpload.css';
import React, { useEffect, useRef } from 'react';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
import { retrieveDataFromDictionary } from '../atoms/Forms/FieldValidator';
import { getDictionaryItem } from '../../utils';
var bytesToSize = function bytesToSize(bytes) {
  if (bytes == 0) return 0;
  var i = Math.floor(Math.log(bytes) / Math.log(1024));
  return bytes / Math.pow(1024, i);
};
var FileUpload = function FileUpload(props) {
  var title = props.title,
    changeHandler = props.changeHandler,
    placeholderText = props.placeholderText,
    name = props.name,
    fieldKey = props.fieldKey,
    singleFile = props.singleFile,
    _props$validate = props.validate,
    validate = _props$validate === void 0 ? true : _props$validate,
    fullWidth = props.fullWidth,
    cssClass = props.cssClass,
    openParent = props.openParent,
    submitted = props.submitted,
    labelCssClass = props.labelCssClass,
    onChangeError = props.onChangeError,
    btnPrimaryClassName = props.btnPrimaryClassName,
    itemId = props.itemId,
    errors = props.errors,
    defaultEvent = props.defaultEvent,
    required = props.required,
    formDictionaries = props.formDictionaries,
    dictionary = props.dictionary;
  var sitecoreContext = React.useContext(SitecoreContextReactContext);
  var rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  var fileUploadCopy = retrieveDataFromDictionary(formDictionaries, 'fileUpload') || {
    phrase: getDictionaryItem(dictionary, 'selectFiles') || '%fileUpload%'
  };
  var deleteDictionaries = retrieveDataFromDictionary(formDictionaries, 'Delete') || {
    phrase: getDictionaryItem(dictionary, 'delete') || '%Delete%'
  };
  var uploadedDocumentDct = retrieveDataFromDictionary(formDictionaries, 'Uploaded document') || {
    phrase: getDictionaryItem(dictionary, 'uploadedDocument') || '%Uploaded document%'
  };
  var MB = retrieveDataFromDictionary(formDictionaries, 'MB') || {
    phrase: getDictionaryItem(dictionary, 'mb') || '%mb%'
  };
  var KB = retrieveDataFromDictionary(formDictionaries, 'KB') || {
    phrase: getDictionaryItem(dictionary, 'kb') || '%kb%'
  };
  var fileSizeUnder = retrieveDataFromDictionary(formDictionaries, 'fileSizeUnder') || {
    phrase: getDictionaryItem(dictionary, 'fileSizeUnder') || '%fileSizeUnder%'
  };
  var fileType = retrieveDataFromDictionary(formDictionaries, 'fileType') || {
    phrase: getDictionaryItem(dictionary, 'fileType') || '%fileType%'
  };
  var fileSize = retrieveDataFromDictionary(formDictionaries, 'fileSize') || {
    phrase: getDictionaryItem(dictionary, 'fileSize') || '%fileSize%'
  };
  var tooBigFiles = retrieveDataFromDictionary(formDictionaries, 'tooBigFiles') || {
    phrase: getDictionaryItem(dictionary, 'tooBigFiles') || '%tooBigFiles%'
  };
  var invalidFilesTypes = retrieveDataFromDictionary(formDictionaries, 'invalidFilesTypes') || {
    phrase: getDictionaryItem(dictionary, 'invalidFilesTypes') || '%invalidFilesTypes%'
  };
  var onlyOneFileIsAllowed = retrieveDataFromDictionary(formDictionaries, 'onlyOneFileIsAllowed') || {
    phrase: getDictionaryItem(dictionary, 'onlyOneFileIsAllowed') || '%onlyOneFileIsAllowed%'
  };
  var allowedContentTypesTitle = retrieveDataFromDictionary(formDictionaries, 'allowedContentTypes') || {
    phrase: getDictionaryItem(dictionary, 'allowedContentTypes') || '%allowedContentTypes%'
  };
  var _React$useState = React.useState([]),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    files = _React$useState2[0],
    setFiles = _React$useState2[1];
  var _React$useState3 = React.useState(false),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    filesSizeError = _React$useState4[0],
    setFilesSizeError = _React$useState4[1];
  var _React$useState5 = React.useState(false),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    filesTypeError = _React$useState6[0],
    setFilesTypeError = _React$useState6[1];
  var _React$useState7 = React.useState(false),
    _React$useState8 = _slicedToArray(_React$useState7, 2),
    filesLengthError = _React$useState8[0],
    setFilesLengthError = _React$useState8[1];
  var fileInputRef = useRef();
  useEffect(function () {
    if (openParent !== null && openParent !== undefined) {
      setTimeout(function () {
        setFilesSizeError(false);
        setFilesTypeError(false);
        setFilesLengthError(false);
      }, 300);
    }
  }, [openParent]);
  useEffect(function () {
    if (!submitted && fileInputRef && fileInputRef.current) {
      fileInputRef.current.value = null;
      setFiles([]);
    }
  }, [submitted]);
  var validateFiles = function validateFiles(newFiles) {
    if (validate) {
      var types = /^text\/plain|pdf|msword|vnd.openxmlformats-officedocument.wordprocessingml.document$/;
      var oversize = newFiles.some(function (file) {
        return file.size > 1024 * 1024 * 2;
      });
      var wrongType = newFiles.some(function (file) {
        return !types.test(file.type);
      });
      var overlength = singleFile ? newFiles.length > 1 : false;
      setFilesSizeError(oversize);
      setFilesTypeError(wrongType);
      setFilesLengthError(overlength);
      setFiles(newFiles.filter(function (file) {
        return file.size <= 1024 * 1024 * 2;
      }).filter(function (file) {
        return types.test(file.type);
      }));
      if (onChangeError) {
        onChangeError(oversize || wrongType || overlength);
      }
    }
  };
  var onChangeEvent = function onChangeEvent(fileList) {
    var filesAdded = Array.from(fileList || []);
    filesAdded = filesAdded.filter(function (file) {
      var contains = false;
      for (var i = 0; i < files.length; i++) {
        if (files[i].name === file.name) {
          contains = true;
          break;
        }
      }
      return !contains;
    });
    var newFiles = files.concat(filesAdded);
    validateFiles(newFiles);
    changeHandler(null, props, newFiles, fieldKey, defaultEvent, null, {
      type: 'file',
      isAdd: true,
      value: props.name
    });
  };
  var removeFileHandler = React.useCallback(function (e, file) {
    e.preventDefault();
    var newFiles = files && Array.from(files).filter(function (currentFile) {
      return currentFile.name !== file.name;
    });
    setFiles(newFiles);
    validateFiles(newFiles);
    changeHandler(null, props, newFiles, fieldKey, defaultEvent, null, {
      type: 'file',
      isAdd: false,
      value: props.name
    });
  }, [files]);
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(fullWidth ? '' : 'col-md-5')
  }, /*#__PURE__*/React.createElement("div", {
    className: "form-group wiz__form-group ".concat(cssClass)
  }, /*#__PURE__*/React.createElement("fieldset", null, /*#__PURE__*/React.createElement("legend", {
    className: "accessibility-hidden-text"
  }, name), title && /*#__PURE__*/React.createElement("label", {
    className: "".concat(required ? 'venue-shortlist__req-label ' : '', "body-small wiz__label file__wiz__label ").concat(labelCssClass),
    htmlFor: itemId
  }, title, required && /*#__PURE__*/React.createElement("span", {
    className: "form-label__marker"
  }, " * ")), /*#__PURE__*/React.createElement("div", {
    className: "file-upload"
  }, /*#__PURE__*/React.createElement("div", {
    className: "file-upload__inner"
  }, singleFile ? /*#__PURE__*/React.createElement("input", {
    className: "file-uploader",
    type: "file",
    ref: fileInputRef,
    onChange: function onChange(e) {
      onChangeEvent(e.target.files);
    },
    onKeyPress: function onKeyPress(event) {
      if (event.key === "Enter" || event.key === "NumpadEnter") {
        // event.preventDefault()
        onChangeEvent(event.target.files);
      }
    },
    placeholder: placeholderText,
    name: fileUploadCopy && fileUploadCopy.phrase,
    id: itemId
  }) : /*#__PURE__*/React.createElement("input", {
    className: "file-uploader",
    type: "file",
    ref: fileInputRef,
    onChange: function onChange(e) {
      onChangeEvent(e.target.files);
    },
    onKeyPress: function onKeyPress(event) {
      if (event.key === "Enter" || event.key === "NumpadEnter") {
        // event.preventDefault()
        onChangeEvent(event.target.files);
      }
    },
    multiple: true,
    placeholder: placeholderText,
    name: fileUploadCopy && fileUploadCopy.phrase,
    id: itemId
  }), /*#__PURE__*/React.createElement("button", {
    tabIndex: -1,
    className: "btn wiz__large-btn ".concat(btnPrimaryClassName ? btnPrimaryClassName : 'btn-primary')
  }, fileUploadCopy && fileUploadCopy.phrase)))), validate ? /*#__PURE__*/React.createElement("div", {
    className: "file-upload__size"
  }, getDictionaryItem(dictionary, 'fileSizeUnder') || '%fileSizeUnder%', " 2 ", MB && MB.phrase || '%mb%', " (.txt, .pdf, .doc, .docx)") : null, /*#__PURE__*/React.createElement("section", null, files.map(function (file, index) {
    var fileSize = Math.round(file.size / 1024);
    fileSize = fileSize === 0 ? 1 : fileSize;
    return /*#__PURE__*/React.createElement("div", {
      className: "file-item",
      key: index
    }, /*#__PURE__*/React.createElement("p", {
      className: "file-item__title"
    }, " ", uploadedDocumentDct && uploadedDocumentDct.phrase, " "), /*#__PURE__*/React.createElement("p", {
      className: "file-item__description"
    }, file.name), /*#__PURE__*/React.createElement("div", {
      className: "file-item__footer"
    }, /*#__PURE__*/React.createElement("span", {
      className: "file-item__size"
    }, fileSize, " ", KB && KB.phrase), /*#__PURE__*/React.createElement("button", {
      className: "btn--reset file-item__action",
      onClick: function onClick(e) {
        return removeFileHandler(e, file);
      },
      onKeyPress: function onKeyPress(e) {
        if (e.which === 13) {
          removeFileHandler(e, file);
        }
      }
    }, deleteDictionaries && deleteDictionaries.phrase)));
  })), /*#__PURE__*/React.createElement("section", null, filesSizeError ? /*#__PURE__*/React.createElement("p", {
    key: "filesSizeError",
    className: "form-field__error form-field__error_big"
  }, tooBigFiles && tooBigFiles.phrase) : null, filesTypeError ? /*#__PURE__*/React.createElement("p", {
    key: "filesTypeError",
    className: "form-field__error form-field__error_big"
  }, invalidFilesTypes && invalidFilesTypes.phrase) : null, filesLengthError ? /*#__PURE__*/React.createElement("p", {
    key: "filesTypeError",
    className: "form-field__error form-field__error_big"
  }, onlyOneFileIsAllowed && onlyOneFileIsAllowed.phrase) : null, errors && errors.map(function (error, index) {
    return /*#__PURE__*/React.createElement("p", {
      key: index,
      className: "form-field__error"
    }, error);
  })))));
};
var StyledWrapper = function StyledWrapper(_ref) {
  var children = _ref.children,
    rtl = _ref.rtl;
  return /*#__PURE__*/React.createElement(ComponentsWrapper, {
    className: "".concat(rtl ? rtlStyles : ltrStyles, " ").concat(styles),
    componentTabIndex: "disabled"
  }, children);
};
var styles = "s1lx4bpc";
var ltrStyles = "l14300gz";
var rtlStyles = "rhif4fn";
export default FileUpload;